/**
 * Animated planet loader displayed while resources load.
 */
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Suspense, lazy } from "react";

const Planet = lazy(() => import("../Planet/Planet"));

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "85vh",

  color: "#FFFFFF",
  textAlign: "center",
  padding: theme.spacing(2),
}));

const Title = styled(Typography)({
  fontSize: "3rem",
  marginBottom: "1rem",
  color: "#952F57",
  fontWeight: "bold",
  fontFamily: "Candara",
});

const SubTitle = styled(Typography)({
  fontSize: "1.5rem",
  marginBottom: "2rem",
  color: "#1C4755",
  fontWeight: "bold",
  fontFamily: "Candara",
});

const LoadingPlanet = ({ title = "Wait a moment please", subtitle = "" }) => {
  return (
    <div className="workzone">
      <Container>
        <Title variant="h1">{title}</Title>
        <SubTitle variant="h2">{subtitle}</SubTitle>
        <Suspense fallback={<div>Cargando...</div>}>
          <Planet />
        </Suspense>
      </Container>
    </div>
  );
};
export default LoadingPlanet;
